import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EaNewComponent } from './ea-new/ea-new.component';
import { EaNewsComponent } from './ea-news/ea-news.component';
import { EaNewSmallComponent } from './ea-new-small/ea-new-small.component';

@NgModule({
  declarations: [EaNewComponent, EaNewsComponent, EaNewSmallComponent],
  imports: [CommonModule],
  exports: [EaNewComponent, EaNewsComponent, EaNewSmallComponent],
})
export class EaNewsModule {}
